// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_wv2","cls2":"ReferenceEvaluationPage-cls2_83C ReferenceEvaluationPage-cls1_wv2","fadeInUp":"ReferenceEvaluationPage-fadeInUp_m_m"};